module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Locking</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection\">\r\n            <label class=\"prop-sublabel label-50\">Time Out</label>\r\n            <div class=\"nopadding-r\">\r\n                <input type=\"text\" name=\"timeout\" value =\"")
    ; __append(escapeFn( timeout ))
    ; __append("\" class=\"label-35\"/> Minutes\r\n            </div>\r\n        </div> \r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 form-group-flex\">\r\n            <input type=\"checkbox\" name=\"showNameOfLockingUser\" class=\"form-radio-group\" ")
    ;  if (showNameOfLockingUser==='true') { 
    ; __append("checked=\"checked\"")
    ;  } 
    ; __append("/> \r\n            <label class=\"form-group-label\">Display name of locking users</label>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 nopadding-r form-group-flex\">\r\n            <input type=\"checkbox\" name=\"confirmBrowserClose\" class=\"form-radio-group\" ")
    ;  if (confirmBrowserClose==='true') { 
    ; __append("checked=\"checked\"")
    ;  } 
    ; __append("/> \r\n            <label class=\"form-group-label\">Show confirm message on browser close</label>\r\n        </div>\r\n    </div>\r\n\r\n")
  }
  return __output;

}